const postActions: { path: string; actions: string }[] = [
  {
    path: "login",
    actions: "Login",
  },
  {
    path: "logout",
    actions: "Log out",
  },
  {
    path: "company/create",
    actions: "Create new company",
  },
  {
    path: "role/permission",
    actions: "Create new permission",
  },
  {
    path: "contact/create",
    actions: "Create new contact",
  },
  {
    path: "country",
    actions: "Create new country coverage",
  },
  {
    path: "vendorApi",
    actions: "Create new vendor API",
  },
  // {
  //   path: "buildings/upload",
  //   actions: "Upload Buildings List",
  // },
  // {
  //   path: "price/upload",
  //   actions: "Upload Price list",
  // },
  {
    path: "quotes/createManual",
    actions: "Create manual Single Site Quote",
  },
  {
    path: "quotes/createManualMultiQuote",
    actions: "Create manual Multi Site Quote",
  },
];
const patchActions: {
  path: string;
  actions: string;
}[] = [
  {
    path: "user/update",
    actions: "Update user",
  },
  {
    path: "user/updateImage",
    actions: "Update user image",
  },
  {
    path: "user/request-password-reset",
    actions: "Request password reset",
  },
  {
    path: "company",
    actions: "Update company",
  },
  {
    path: "role",
    actions: "Update role",
  },
  {
    path: "contact",
    actions: "Update contact list",
  },
  {
    path: "country/coverage",
    actions: "Update country coverage",
  },
  {
    path: "vendorApi",
    actions: "Update vendor API",
  },
  {
    path: "buildings",
    actions: "Update buildings list",
  },
  {
    path: "documents",
    actions: "Update document",
  },
  {
    path: "prices",
    actions: "Update price list",
  },
  {
    path: "quotes/createFirm",
    actions: "Create quote",
  },
  {
    path: "quotes/save",
    actions: "Create quote",
  },
  {
    path: "quotes/enquire",
    actions: "Create quote",
  },
  {
    path: "quotes/winPrice",
    actions: "Create quote",
  },
  {
    path: "quotes/toCustomer",
    actions: "Update quote",
  },
  {
    path: "quotes/toVendor",
    actions: "Update quote",
  },
  {
    path: "quotes/createManual",
    actions: "Create quote",
  },
  {
    path: "quotes/createManualMultiQuote",
    actions: "Create quote",
  },
];
const deleteActions: {
  path: string;
  actions: string;
}[] = [
  {
    path: "user/signUp/reject",
    actions: "Reject sign up request",
  },
  {
    path: "user/delete",
    actions: "Delete user",
  },
  {
    path: "company",
    actions: "Delete company",
  },
  {
    path: "role/permission",
    actions: "Delete permission",
  },
  {
    path: "contact",
    actions: "Delete contact list",
  },
  {
    path: "country",
    actions: "Delete country",
  },
  {
    path: "vendorApi",
    actions: "Delete vendor API",
  },
  {
    path: "buildings",
    actions: "Delete building",
  },
  {
    path: "documents",
    actions: "Delete documents",
  },
  {
    path: "prices",
    actions: "Delete price",
  },
];
export { postActions, deleteActions, patchActions };
